<template>
  <div>
    <b-container class="message">
      <h4>Please, enter your credentials to access to Automatic<span style="color: #e2001a">TV</span> Live</h4>
    </b-container>
    <b-container>
      <b-form @submit="onSubmit" @reset="onReset">
        <b-form-group id="input-group-1" label="Username:" label-for="input-1">
          <b-form-input id="input-1" v-model="username" required placeholder="Username"></b-form-input>
        </b-form-group>
        <b-form-group id="input-group-2" label="Password:" label-for="input-2">
          <b-form-input
            id="input-2"
            v-model="password"
            required
            type="password"
            placeholder="Password"
          ></b-form-input>
        </b-form-group>
        <b-button type="submit" variant="primary">Submit</b-button>
        <b-button type="reset" variant="secondary">Reset</b-button>
      </b-form>
    </b-container>
    <br />
    <br />
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "LoginForm",
  data() {
    return {
      username: "",
      password: ""
    };
  },
  mounted() {
    this.track()
  },
  methods: {
    track () {
      this.$ga.page({
        page: '/login',
        title: 'Login',
        location: window.location.href
      })
    },
    onReset(evt) {
      evt.preventDefault();
      this.username = "";
      this.password = "";
    },
    onSubmit(evt) {
      evt.preventDefault();
      axios
        .post("api/login/", {
          username: this.username,
          password: this.password
        })
        .then(response => {
          this.$emit("logged", response.data.token);
        })
        .catch(error => {
          console.log(error);
          alert("Invalid credentials");
        });
    }
  }
};
</script>
